<template>

    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner :admin="false" />
    </b-container>

    <b-container v-else>

        <b-container v-if="feed && feed.length" 
                    class="contaier-feed">
            <b-row>

                <b-col lg="4" md="6"
                        class="p-10"
                        v-for="(item, index) in feed" 
                        :key="index">

                    <feed-item :item="item" 
                                :index="index" 
                                @delete="deleteAudit" />

                </b-col>
            </b-row>
        </b-container> 

        <b-container v-else class="container-stub">
        
            <b-row class="m-0 center">
                <b-img src="/img/lenta-empty.png"/>
            </b-row>

            <b-row class="center first-level">
                Здесь пока пусто
            </b-row>

            <b-row class="m-0 center second-level">
                Создайте новый аудит, и он появится в ленте
            </b-row>

        </b-container>

        <b-img src="/img/btn-plus.png"
            id="btn-add-audit" 
            class="button-plus" 
            @click="addAuditRedirect"/>

    </b-container> 
  
</template>

<script>
import '@/assets/styles/client/audit/auditFeed.css'

import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import AllRoutes from '@/routes/all.routes.js'

import FeedListModel from '@/store/models/client/audit/FeedList'
import FeedItem from '@/components/client/audit/FeedItem'

import Loading from '@/store/models/Loading'
import Spinner from "@/components/shared/Spinner"

export default {

   components: {
      Spinner,
      FeedItem
    },
    data: function() {
      let load = new Loading();
      this.getFeed(load);

      return {
        feed: [],
        load: load
      }
    },
    methods: {
        getFeed: function(load) {
            load.Calculate(true);
            apiService.Client.Feed.GetAll()
                .then((response) => {
                    this.feed = FeedListModel.mapFromDto(response.data);            
                    load.Calculate(false);
                })
                .catch(error => load.Calculate(false));
        },

        addAuditRedirect: function() {
            this.$router.push(AllRoutes.Client.Audit.Add);
        },

        deleteAudit: function(audit) {
            this.load.Calculate(true);

            apiService.Client.Audit.PostDelete(audit.Id)
                .then(response => this.$router.go(this.$router.currentRoute))
                .catch(error => this.load.Calculate(false));
        }
    }    
};
</script>